module.exports = __webpack_public_path__ + "img/jpg.99f11d1b.svg";